import { LightState } from './protocol';

/**
 * 17 color codes from Protocol B for traffic light groups
 * Each code maps to a specific combination of red/amber/green states
 */
export enum ColorCode {
  D = 'D', // Apagado (dark)
  V = 'V', // Verde fijo
  A = 'A', // Ámbar fijo
  R = 'R', // Rojo fijo
  N = 'N', // Negro (todo apagado, diferente a D)
  S = 'S', // Verde parpadeante
  C = 'C', // Ámbar parpadeante
  F = 'F', // Rojo parpadeante
  B = 'B', // Rojo + ámbar (preparación)
  P = 'P', // Verde peatonal
  H = 'H', // Rojo peatonal
  I = 'I', // Verde peatonal parpadeante
  J = 'J', // Rojo + verde (error visible)
  G = 'G', // Verde rápido parpadeante
  E = 'E', // Ámbar rápido parpadeante
  K = 'K', // Alternante rojo-verde
  Z = 'Z', // Alternante rojo-ámbar
}

export type GroupType = 'V' | 'P' | 'S'; // vehicular, peatonal, especial

export interface GroupDefinition {
  id: number;
  type: GroupType;
  label: string;
  position: [number, number]; // [lng, lat]
  bearing: number; // degrees, 0=north
  phaseColors: Record<string, ColorCode>; // phase id (F1..F4) → color code
}

export type DetectorHardwareType = 'loop' | 'pushbutton';

export interface DetectorDefinition {
  id: number;
  type: DetectorHardwareType;
  label: string;
  position: [number, number]; // [lng, lat]
  bearing?: number;
  size?: [number, number]; // [width, height] in meters, for loops
}

export interface IntersectionGeometry {
  lanes: GeoJSON.Feature<GeoJSON.LineString>[];
  crosswalks: GeoJSON.Feature<GeoJSON.Polygon>[];
  intersectionArea: GeoJSON.Feature<GeoJSON.Polygon>;
}

export interface CabinetDefinition {
  position: [number, number]; // [lng, lat]
  logicalId: number;
  physicalId: string;
}

export interface IntersectionDefinition {
  id: string;
  name: string;
  center: [number, number]; // [lng, lat]
  zoom: number;
  bearing: number;
  pitch: number;
  cabinet: CabinetDefinition;
  groups: GroupDefinition[];
  detectors: DetectorDefinition[];
  geometry: IntersectionGeometry;
  phaseOffset?: number; // 0-3: shifts phase by N positions (F1→F2→F3→F4)
}

/**
 * Light state for a single traffic light (3 or 2 lights)
 */
export interface TrafficLightState {
  red: LightState;
  amber: LightState;
  green: LightState;
}
